module.exports = __webpack_public_path__ + "static/img/circulate.0533211f.svg";